import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=BUYBOX_LOGGED_IN_EXP:control
// ?preferred_variant=BUYBOX_LOGGED_IN_EXP:variant_1

// ?remove_preferred_experiment=BUYBOX_LOGGED_IN_EXP

export const BuyboxLoggedInExpName = 'BUYBOX_LOGGED_IN_EXP' as const;

export type BuyboxLoggedInExpVariants = ToVariants<typeof BuyboxLoggedInExpVariants>;

export const BuyboxLoggedInExpVariants = {
	CONTROL: 'control',
	VARIANT_1: 'variant_1',
} as const;

export default generate(
	BuyboxLoggedInExpName,
	BuyboxLoggedInExpVariants,
	() => {
		return true;
	},
	async instance => {
		return !!instance.$store.getters['user/isLoggedIn'];
	}
);

export type BuyboxLoggedInExpAffiliateTagsType = Record<
	BuyboxLoggedInExpVariants,
	Record<
		string,
		Partial<
			Record<
				'RO' | 'FT' | 'QTV',
				{
					ct: string;
					itsct?: string;
				}
			>
		>
	>
>;
export const BuyboxLoggedInExpAffiliateTags: BuyboxLoggedInExpAffiliateTagsType = {
	[BuyboxLoggedInExpVariants.CONTROL]: {
		atp: {
			RO: {
				ct: 'apple-<country>-web-ro-bbxexp-ctrl',
			},
			FT: {
				ct: 'apple-<country>-web-ft-bbxexp-ctrl',
			},
			QTV: {
				ct: 'apple-<country>-app-qtv-<type>-bbxexp-ctrl', // type 'cta or 'title'
			},
		},
		amp: {
			RO: {
				ct: 'amz-<country>-app-ro-bbxexp-ctrl',
			},
			FT: {
				ct: 'amz-<country>-app-ft-bbxexp-ctrl',
			},
			QTV: {
				ct: 'amz-<country>-app-qtv-<type>-bbxexp-ctrl', // type 'cta or 'title'
			},
		},
		prv: {
			RO: {
				ct: 'amz-<country>-app-ro-bbxexp-ctrl',
			},
			FT: {
				ct: 'amz-<country>-app-ft-bbxexp-ctrl',
			},
			QTV: {
				ct: 'amz-<country>-app-qtv-<type>-bbxexp-ctrl', // type 'cta or 'title'
			},
		},
		cru: {
			RO: {
				ct: 'cr-<country>-app-ro-bbxexp-ctrl',
			},
			FT: {
				ct: 'cr-<country>-app-ft-bbxexp-ctrl',
			},
		},
		dnp: {
			RO: {
				ct: 'disney-<country>-app-ro-bbxexp-ctrl',
			},
			FT: {
				ct: 'disney-<country>-app-ft-bbxexp-ctrl',
			},
		},
		hlu: {
			RO: {
				ct: 'hulu-<country>-app-ro-bbxexp-ctrl',
			},
			FT: {
				ct: 'hulu-<country>-app-ft-bbxexp-ctrl',
			},
		},
	},

	[BuyboxLoggedInExpVariants.VARIANT_1]: {
		atp: {
			RO: {
				ct: 'apple-<country>-web-ro-bbxexp-v1',
				itsct: 'juswatch_tv_2',
			},
			FT: {
				ct: 'apple-<country>-web-ft-bbxexp-v1',
				itsct: 'juswatch_tv_2',
			},
			QTV: {
				ct: 'apple-<country>-web-qtv-<type>-bbxexp-v1', // type 'cta or 'title'
				itsct: 'juswatch_tv_2',
			},
		},
		amp: {
			RO: {
				ct: 'amz-<country>-app-ro-bbxexp-v1',
			},
			FT: {
				ct: 'amz-<country>-app-ft-bbxexp-v1',
			},
			QTV: {
				ct: 'amz-<country>-app-qtv-<type>-bbxexp-v1', // type 'cta or 'title'
			},
		},
		prv: {
			RO: {
				ct: 'amz-<country>-app-ro-bbxexp-v1',
			},
			FT: {
				ct: 'amz-<country>-app-ft-bbxexp-v1',
			},
			QTV: {
				ct: 'amz-<country>-app-qtv-<type>-bbxexp-v1', // type 'cta or 'title'
			},
		},
		cru: {
			RO: {
				ct: 'cr-<country>-app-ro-bbxexp-v1',
			},
			FT: {
				ct: 'cr-<country>-app-ft-bbxexp-v1',
			},
			QTV: {
				ct: 'cr-<country>-app-qtv-<type>-bbxexp-v1', // type 'cta or 'title'
			},
		},
		dnp: {
			RO: {
				ct: 'disney-<country>-app-ro-bbxexp-v1',
			},
			FT: {
				ct: 'disney-<country>-app-ft-bbxexp-v1',
			},
			// QTV: {
			// 	ct: 'disney-<country>-app-qtv-cta-<type>-v1', // type 'cta or 'title'
			// },
		},
		hlu: {
			RO: {
				ct: 'hulu-<country>-app-ro-bbxexp-v1',
			},
			FT: {
				ct: 'hulu-<country>-app-ft-bbxexp-v1',
			},
			// QTV: {
			// 	ct: 'hulu-<country>-app-qtv-cta-<type>-bbxexp-v1', // type 'cta or 'title'
			// },
		},
	},
};
